import {
  ChevronDownIcon,
  ChevronLeftIcon,
  TriangleDownIcon,
  TriangleUpIcon
} from '@chakra-ui/icons';
import {
  Box,
  Button,
  Fade,
  Flex,
  HStack,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Table,
  Text,
  useBreakpointValue,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import exportFromJSON from 'export-from-json';
import { useCallback, useEffect, useState } from 'react';
import { HiPlusCircle } from 'react-icons/hi';
import { Column } from 'react-table';
import MaskedInput from 'react-text-mask';

import { InteractiveTable } from '../../../components/data/InteractiveTable';
import { ValueCard } from '../../../components/data/ValueCard';
import { api } from '../../../services/api';
import { apiSensedia } from '../../../services/api-sensedia';
import { cpf } from '../../../utils/masks';

type Table = {
  NOME_CLIENTE: string;
  CPF: string;
  PROPOSTA: number;
  TIPO: string;
  ORIGEM: string;
  DESTINO: string;
  DATA_SOLICITACAO: string;
  DATA_EFETIVACAO: string;
  // VALOR: string;
  STATUS: string;
};

type Data = {
  summarized: {
    income: string;
    outcome: string;
    incomeAmount: string;
    outcomeAmount: string;
  };
  table: Table[];
};

const PORTABILIDADE_REQUEST_TIMEOUT_MS = Number(
  process.env.REACT_APP_PORTABILIDADE_REQUEST_TIMEOUT_MS || 5500
);
const PORTABILIDADE_POLLING_MAX_ATTEMPTS = Number(
  process.env.REACT_APP_PORTABILIDADE_POLLING_MAX_ATTEMPTS || 20
);
const PORTABILIDADE_POLLING_DEFAULT_INTERVAL_MS = Number(
  process.env.REACT_APP_PORTABILIDADE_POLLING_INTERVAL_MS || 700
);

const wait = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const ConsultaPortabilidades = (): JSX.Element => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [pollingInProgress, setPollingInProgress] = useState(false);

  const [data, setData] = useState<Data>({
    summarized: {
      income: '0',
      outcome: '0',
      incomeAmount: '0',
      outcomeAmount: '0'
    },
    table: [
      {
        NOME_CLIENTE: '',
        CPF: '',
        PROPOSTA: 0,
        TIPO: '',
        ORIGEM: '',
        DESTINO: '',
        DATA_SOLICITACAO: '',
        DATA_EFETIVACAO: '',
        // VALOR: '',
        STATUS: ''
      }
    ]
  });

  const [table, setTable] = useState<Table[]>([
    {
      NOME_CLIENTE: '',
      CPF: '',
      PROPOSTA: 0,
      TIPO: '',
      ORIGEM: '',
      DESTINO: '',
      DATA_SOLICITACAO: '',
      DATA_EFETIVACAO: '',
      // VALOR: '',
      STATUS: ''
    }
  ]);

  const [income, setIncome] = useState('0');
  const [outcome, setOutcome] = useState('0');
  const [incomeAmount, setIncomeAmount] = useState('0');
  const [outcomeAmount, setOutcomeAmount] = useState('0');

  const [itemsCount, setItemsCount] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  const [moreFilters, setMoreFilters] = useState(false);
  const [requestDateFilter, setRequestDateFilter] = useState('');
  const [achievementDateFilter, setAchievementDateFilter] = useState('');
  const [nameFilter, setNameFilter] = useState('');
  const [cpfFilter, setCpfFilter] = useState('');
  const [originFilter, setOriginFilter] = useState('');
  const [destinyFilter, setDestinyFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const columns: Column<object>[] = [
    {
      Header: 'Nome',
      accessor: 'NOME_CLIENTE'
    },
    {
      Header: 'CPF',
      accessor: 'CPF'
    },
    {
      Header: 'Proposta',
      accessor: 'PROPOSTA'
    },
    {
      Header: 'Tipo',
      accessor: 'TIPO'
    },
    {
      Header: 'Origem',
      accessor: 'ORIGEM'
    },
    {
      Header: 'Destino',
      accessor: 'DESTINO'
    },
    {
      Header: 'Data da solicitação',
      accessor: 'DATA_SOLICITACAO'
    },
    {
      Header: 'Data da efetivação',
      accessor: 'DATA_EFETIVACAO'
    },
    // {
    //   Header: 'Valor',
    //   accessor: 'VALOR',
    //   Cell: ({ row }: { row: { original: { VALOR: string } } }) => (
    //     <Text>R$ {parseFloat(row.original.VALOR).toLocaleString('PT-BR')}</Text>
    //   )
    // },
    {
      Header: 'Status',
      accessor: 'STATUS'
    }
  ];

  const handleFilter = async () => {
    setLoadingTable(true);

    if (cpfFilter.length > 0 && cpfFilter.length < 14) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });

      setLoadingTable(false);

      return;
    }

    try {
      await getData();
    } catch (error: any) {
      handlePortabilidadeRequestError(error);
    } finally {
      setLoadingTable(false);
    }

    // if (nameFilter.length > 0) {
    //   const newTable = data.table.filter((item) =>
    //     item.NOME_CLIENTE.toLowerCase().includes(
    //       nameFilter.toLowerCase().replaceAll(/\s/g, '')
    //     )
    //   );

    //   setTable(newTable);
    //   setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    // }

    // if (cpfFilter.length > 0) {
    //   const newTable = data.table.filter((item) =>
    //     item.CPF.includes(cpfFilter.replaceAll('.', '').replace('-', ''))
    //   );

    //   setTable(newTable);
    //   setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    // }

    // if (originFilter.length > 0) {
    //   const newTable = data.table.filter((item) =>
    //     item.ORIGEM.toLowerCase().includes(
    //       originFilter.toLowerCase().replaceAll(/\s/g, '')
    //     )
    //   );

    //   setTable(newTable);
    //   setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    // }

    // if (destinyFilter.length > 0) {
    //   const newTable = data.table.filter((item) =>
    //     item.DESTINO.toLowerCase().includes(
    //       destinyFilter.toLowerCase().replaceAll(/\s/g, '')
    //     )
    //   );

    //   setTable(newTable);
    //   setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    // }

    // if (requestDateFilter.length > 0) {
    //   const newTable = data.table.filter((item) =>
    //     item.DATA_SOLICITACAO.toLowerCase().includes(
    //       requestDateFilter.toLowerCase().replaceAll(/\s/g, '')
    //     )
    //   );

    //   setTable(newTable);
    //   setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    // }

    // if (achievementDateFilter.length > 0) {
    //   const newTable = data.table.filter((item) =>
    //     item.DATA_SOLICITACAO.toLowerCase().includes(
    //       achievementDateFilter.toLowerCase().replaceAll(/\s/g, '')
    //     )
    //   );

    //   setTable(newTable);
    //   setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    // }

  };

  const handleClearFilters = async () => {
    setLoading(true);

    setCpfFilter('');
    setNameFilter('');
    setStatusFilter('');
    setOriginFilter('');
    setDestinyFilter('');

    setRequestDateFilter('');
    setAchievementDateFilter('');

    setMoreFilters(false);

    try {
      await getData({
        requestDate: '',
        achievementDate: '',
        name: '',
        origin: '',
        destiny: '',
        status: '',
        cpf: ''
      });
    } catch (error: any) {
      handlePortabilidadeRequestError(error);
    } finally {
      setLoading(false);
    }
  };

  const checkLGPD = useCallback(async (table: Table[]) => {
    const count = table
      .map((item) => `${item.CPF} + ${item.PROPOSTA}`)
      .filter((value, index, self) => self.indexOf(value) === index);

    return count.length;
  }, []);

  type PortabilidadeFilters = {
    requestDate: string;
    achievementDate: string;
    name: string;
    origin: string;
    destiny: string;
    status: string;
    cpf: string;
  };

  const buildRequestUrl = useCallback(
    (filters: PortabilidadeFilters): string => {
      return `/gestao-de-carteiras/movimentacoes-portabilidades?dataSolicitacao=${
        filters.requestDate
      }&dataEfetivacao=${filters.achievementDate}&nome=${filters.name}&origem=${
        filters.origin
      }&destino=${filters.destiny}&status=${filters.status}&cpf=${filters.cpf
        .replaceAll('.', '')
        .replace('-', '')}`;
    },
    []
  );

  const handlePortabilidadeRequestError = useCallback(
    (error: any): void => {
      setPollingInProgress(false);

      if (error?.response?.status === 401) {
        onOpen();
        return;
      }

      const pollingTimedOut =
        error?.message === 'PORTABILIDADE_POLLING_TIMEOUT';
      const errorObj = error?.toJSON?.();
      const hasStatus = errorObj?.status || error?.response?.data?.statusCode;
      const hasMessage = errorObj?.message || error?.response?.data?.message;

      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {pollingTimedOut
                ? 'A consulta ainda está sendo processada. Aguarde alguns instantes e tente novamente.'
                : 'Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns minutos e tente fazer login novamente, se persistir, por favor entrar em contato.'}
            </Text>
            <Text>
              {hasStatus && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {hasStatus && (
                <>{errorObj?.status ?? error?.response?.data?.statusCode}</>
              )}
              {hasStatus && hasMessage && ' - '}
              {hasMessage && (
                <>{error?.response?.data?.message ?? errorObj?.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
    },
    [onOpen, toast]
  );

  const fetchPortabilidadesWithPolling = useCallback(
    async (filters: PortabilidadeFilters): Promise<any> => {
      const requestUrl = buildRequestUrl(filters);

      setPollingInProgress(false);

      for (
        let attempt = 1;
        attempt <= PORTABILIDADE_POLLING_MAX_ATTEMPTS;
        attempt++
      ) {
        try {
          const response = await apiSensedia.get(requestUrl, {
            timeout: PORTABILIDADE_REQUEST_TIMEOUT_MS
          });

          const inProgress =
            response.status === 202 || response?.data?.status === 'in_progress';

          if (!inProgress) {
            setPollingInProgress(false);
            return response;
          }

          setPollingInProgress(true);

          const retryAfterMs = Number(
            response?.data?.retryAfterMs ||
              PORTABILIDADE_POLLING_DEFAULT_INTERVAL_MS
          );

          if (attempt < PORTABILIDADE_POLLING_MAX_ATTEMPTS) {
            await wait(retryAfterMs);
          }
        } catch (error: any) {
          const status = error?.response?.status;

          if (status === 504 && attempt < PORTABILIDADE_POLLING_MAX_ATTEMPTS) {
            setPollingInProgress(true);
            await wait(PORTABILIDADE_POLLING_DEFAULT_INTERVAL_MS);
            continue;
          }

          setPollingInProgress(false);
          throw error;
        }
      }

      setPollingInProgress(false);
      throw new Error('PORTABILIDADE_POLLING_TIMEOUT');
    },
    [buildRequestUrl]
  );

  const applyResponseData = useCallback(
    async (response: any): Promise<void> => {
      if (!response?.data?.data?.table) return;

      setData({
        summarized: {
          income: response.data.data.summarize.income.toLocaleString('pt-BR'),
          outcome: response.data.data.summarize.outcome.toLocaleString('pt-BR'),
          incomeAmount: response.data.data.summarize.incomeAmount,
          outcomeAmount: response.data.data.summarize.outcomeAmount
        },
        table: response.data.data.table
      });

      const howManyDistinct = await checkLGPD(response.data.data.table);

      setTable(response.data.data.table);
      setIncomeAmount(response.data.data.summarize.incomeAmount);
      setOutcomeAmount(response.data.data.summarize.outcomeAmount);
      setOutcome(response.data.data.summarize.outcome);
      setIncome(
        howManyDistinct > 2
          ? response.data.data.summarize.income.toLocaleString('pt-BR')
          : '-'
      );
      setOutcome(
        howManyDistinct > 2
          ? response.data.data.summarize.outcome.toLocaleString('pt-BR')
          : '-'
      );
      setItemsCount(
        response.data.data.table.length > 10
          ? 10
          : response.data.data.table.length
      );
    },
    [checkLGPD]
  );

  const getData = useCallback(
    async (overrideFilters?: Partial<PortabilidadeFilters>): Promise<void> => {
      const filters: PortabilidadeFilters = {
        requestDate: requestDateFilter,
        achievementDate: achievementDateFilter,
        name: nameFilter,
        origin: originFilter,
        destiny: destinyFilter,
        status: statusFilter,
        cpf: cpfFilter,
        ...overrideFilters
      };

      const response = await fetchPortabilidadesWithPolling(filters);
      await applyResponseData(response);
    },
    [
      achievementDateFilter,
      applyResponseData,
      cpfFilter,
      destinyFilter,
      fetchPortabilidadesWithPolling,
      nameFilter,
      originFilter,
      requestDateFilter,
      statusFilter
    ]
  );

  const fetchDataTreatingTimeout = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      await getData();
    } catch (error: any) {
      handlePortabilidadeRequestError(error);
    } finally {
      setLoading(false);
    }
  }, [getData, handlePortabilidadeRequestError]);

  const exportData = (ext: 'csv' | 'xls') => {
    const data = formatDataEfetivado();
    const fileName = `Dados`;
    const exportType = exportFromJSON.types[ext];

    exportFromJSON({ data, fileName, exportType });
  };

  const formatDataEfetivado = (): Array<{
    nomeCliente: string;
    cpfCliente: string;
    proposta: number;
    tipo: string;
    origem: string;
    destino: string;
    dataSolicitacao: string;
    dataEfetivacao: string;
    status: string;
  }> => {
    return data.table.map((item) => {
      return {
        nomeCliente: item.NOME_CLIENTE,
        cpfCliente: item.CPF,
        proposta: item.PROPOSTA,
        tipo: item.TIPO,
        origem: item?.ORIGEM,
        destino: item?.DESTINO,
        dataSolicitacao: item.DATA_SOLICITACAO,
        dataEfetivacao: item.DATA_EFETIVACAO,
        status: item.STATUS
      };
    });
  };

  useEffect(() => {
    fetchDataTreatingTimeout();
  }, [fetchDataTreatingTimeout]);

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  return (
    <Stack p="1.7vw 11.5vw" spacing={23}>
      <Stack spacing={7}>
        <Stack spacing={1}>
          <Link href="/corretor" w="4rem">
            <HStack spacing={0}>
              <ChevronLeftIcon />
              <Text fontSize="1rem" color="#696969" fontWeight="bold">
                Voltar
              </Text>
            </HStack>
          </Link>
          <Flex justifyContent="space-between" alignItems="center">
            <Text color="#00335E" fontWeight="bold" fontSize="1.2rem">
              Portabilidade
            </Text>
            <Menu>
              <MenuButton
                bg="none"
                variant="outline"
                border="1px"
                borderColor="#1B365D"
                color="#1B365D"
                fontSize="0.8rem"
                as={Button}
                rightIcon={<ChevronDownIcon />}
              >
                Exportar Dados
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => exportData('csv')}>
                  Baixar .csv
                </MenuItem>
                <MenuItem onClick={() => exportData('xls')}>
                  Baixar .xls
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Stack>
        <Stack
          bg="#fff"
          borderRadius="1rem"
          minH="4.3rem"
          pointerEvents={!loading ? 'all' : 'none'}
          opacity={!loading ? '1' : '0.4'}
        >
          <HStack
            wrap="wrap"
            justify={isWideVersion ? 'flex-start' : 'center'}
            flexDir={{ base: 'column', lg: 'row' }}
          >
            <HStack
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
              m=".6rem !important"
            >
              <Text fontSize=".8rem" fontWeight="bold" color="#1B365D">
                Filtrar:
              </Text>
              <Input
                color="#1B365D"
                fontSize=".7rem"
                w="10.3rem"
                h="2.1rem"
                placeholder="Nome"
                value={nameFilter}
                onChange={(e) => {
                  setNameFilter(e.target.value);
                }}
              />

              <Input
                as={MaskedInput}
                mask={cpf}
                guide={false}
                color="#1B365D"
                fontSize=".7rem"
                w="9.3rem"
                h="2.1rem"
                placeholder="CPF"
                value={cpfFilter}
                onChange={(e) => {
                  setCpfFilter(e.target.value);
                }}
              />
            </HStack>
            <HStack
              flexGrow="2"
              justify="space-between"
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
            >
              <Button
                bg="#FA6B25"
                color="#fff"
                fontSize=".7rem"
                w="7.5rem"
                h="2.1rem"
                isLoading={loading}
                onClick={handleFilter}
                m="0 !important"
                _hover={{
                  opacity: '.9'
                }}
              >
                Filtrar
              </Button>
              <Button
                bg="#ACACAC"
                color="#fff"
                fontSize=".7rem"
                w="7.5rem"
                h="2.1rem"
                float="right"
                justifySelf="end"
                onClick={async () => {
                  handleClearFilters();
                }}
                m={{
                  md: '.3rem !important',
                  lg: '.3rem !important'
                }}
                marginRight=".6rem !important"
                _hover={{
                  opacity: '.9'
                }}
              >
                Limpar Filtros
              </Button>
            </HStack>
          </HStack>

          <Box m=".6rem !important">
            <Box>
              <Button
                variant="ghost"
                outline="none"
                rightIcon={
                  moreFilters ? <TriangleUpIcon /> : <TriangleDownIcon />
                }
                _hover={{ bg: 'transparent' }}
                p="0"
                _focus={{
                  outline: 'none !important',
                  boxShadow: 'none !important'
                }}
                _active={{ bg: 'transparent' }}
                fontSize=".8rem"
                fontWeight="bold"
                color="#1B365D"
                cursor="pointer"
                onClick={() => {
                  if (moreFilters === false) {
                    setOriginFilter('');
                    setDestinyFilter('');
                    setRequestDateFilter('');
                    setAchievementDateFilter('');
                    setStatusFilter('');
                  }
                  setMoreFilters(!moreFilters);
                }}
              >
                {moreFilters ? 'Menos Filtros' : 'Mais Filtros'}
              </Button>
            </Box>
            {moreFilters && (
              <HStack
                wrap="wrap"
                justify={isWideVersion ? 'flex-start' : 'center'}
                flexDir={{ base: 'column', lg: 'row' }}
                mt="0"
              >
                <Input
                  color="#1B365D"
                  fontSize=".7rem"
                  w="9.3rem"
                  h="2.1rem"
                  placeholder="Origem"
                  value={originFilter}
                  onChange={(e) => {
                    setOriginFilter(e.target.value);
                  }}
                />

                <Input
                  color="#1B365D"
                  fontSize=".7rem"
                  w="9.3rem"
                  h="2.1rem"
                  placeholder="Destino"
                  value={destinyFilter}
                  onChange={(e) => {
                    setDestinyFilter(e.target.value);
                  }}
                />

                <Select
                  color="#1B365D"
                  fontSize=".7rem"
                  w="8rem"
                  h="2.1rem"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="Em Liquidação">Em Liquidação</option>
                  <option value="Pendente">Pendente</option>
                  <option value="Liberada">Liberada</option>
                  <option value="Transito">Transito</option>
                  <option value="Analise">Analise</option>
                  <option value="Finalizado">Finalizado</option>
                </Select>

                {/* <FormLabel fontSize=".7rem">Data da solicitação</FormLabel>
                <Input
                  color="#1B365D"
                  onChange={(e) => {
                    setRequestDateFilter(e.target.value);
                  }}
                  value={requestDateFilter}
                  fontSize=".7rem"
                  type="date"
                  w="8.1rem"
                  h="2.1rem"
                  placeholder="Data da solicitação"
                />
                <FormLabel fontSize=".7rem">Data da efetivação</FormLabel>
                <Input
                  color="#1B365D"
                  onChange={(e) => {
                    setAchievementDateFilter(e.target.value);
                  }}
                  fontSize=".7rem"
                  value={achievementDateFilter}
                  type="date"
                  w="8.1rem"
                  h="2.1rem"
                  placeholder="Data da efetivação"
                /> */}
              </HStack>
            )}
          </Box>
        </Stack>
      </Stack>
      {loading ? (
        <Flex w="100%" justify="center">
          <Stack align="center">
            <Spinner />
            {pollingInProgress && (
              <Text color="#1B365D" fontSize=".9rem">
                Consulta em andamento. Atualizando os dados...
              </Text>
            )}
          </Stack>
        </Flex>
      ) : (
        <Fade in={!loading}>
          <Stack
            bg="#fff"
            color="#00335E"
            borderRadius="1rem"
            p="1.4rem 1.1rem .8rem"
          >
            <Flex wrap="wrap" gap="5" justify="center">
              <ValueCard
                value={incomeAmount}
                description="Quantidade de portabilidade de entrada"
              />
              <ValueCard
                prefix={income === '-' ? '' : 'R$'}
                value={income}
                fontSize="1.5rem"
                description="Valor portabilidade de entrada"
              />

              <ValueCard
                value={outcomeAmount}
                description="Quantidade portabilidade de saída"
              />

              <ValueCard
                prefix={outcome === '-' ? '' : 'R$'}
                value={outcome}
                fontSize="1.5rem"
                description="Valor portabilidade de saída"
              />
            </Flex>

            {loadingTable ? (
              <Flex w="100%" justify="center">
                <Stack align="center">
                  <Spinner />
                  {pollingInProgress && (
                    <Text color="#1B365D" fontSize=".9rem">
                      Consulta em andamento. Atualizando os dados...
                    </Text>
                  )}
                </Stack>
              </Flex>
            ) : (
              <InteractiveTable
                sort="NOME_CLIENTE"
                columns={columns}
                data={table}
                itemsCount={itemsCount}
              />
            )}
          </Stack>
          <Flex
            w="100%"
            justify="flex-end"
            fontSize=".9rem"
            align="center"
            mt="2rem"
          >
            <Flex
              w={{ base: '100%', lg: '60%' }}
              justify={{ base: 'center', lg: 'space-between' }}
              flexDir={{ base: 'column', lg: 'row' }}
            >
              {!loadingTable && (
                <>
                  <Flex
                    align="center"
                    cursor="pointer"
                    justify="center"
                    onClick={() => {
                      setItemsCount(
                        itemsToShow + itemsCount > table.length
                          ? table.length
                          : itemsToShow + itemsCount
                      );
                    }}
                  >
                    <HiPlusCircle size={26} color="#00335E" />
                    <Text>
                      Mais itens (exibindo {itemsCount}/{table.length})
                    </Text>
                  </Flex>
                  <Box>
                    <Select
                      border="1px solid #00335E !important"
                      borderRadius="1rem !important"
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setItemsToShow(parseInt(e.target.value))
                      }
                    >
                      <option value={5}>exibir mais 5 por vez</option>
                      <option value={10}>exibir mais 10 por vez</option>
                      <option value={20}>exibir mais 20 por vez</option>
                      <option value={40}>exibir mais 40 por vez</option>
                    </Select>
                  </Box>
                </>
              )}
            </Flex>
          </Flex>
        </Fade>
      )}

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Atenção!</ModalHeader>
          <ModalBody>
            <Text>Ops, sua sessão expirou.</Text>
            <Text>
              Por favor, faça novamente o login no Portal do Corretor.
            </Text>
          </ModalBody>

          <ModalFooter justifyContent="center">
            <Link href={process.env.REACT_APP_PORTAL_URL}>
              <Button bg="#FA6B25" color="#fff" colorScheme="orange">
                Voltar
              </Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Stack>
  );
};
